import { render, staticRenderFns } from "./ChemiFolderCard.vue?vue&type=template&id=43362f8e&"
import script from "./ChemiFolderCard.vue?vue&type=script&lang=ts&"
export * from "./ChemiFolderCard.vue?vue&type=script&lang=ts&"
import style0 from "./ChemiFolderCard.vue?vue&type=style&index=0&id=43362f8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports